import React from 'react'
import { logger } from '../../logging'

import { Text, View, Flex } from '@aws-amplify/ui-react'



import { convertSecondsToHMSShort, getLabelForInstanceType } from '../Common'
import { VpnWithMetrics } from '../../pages/Home'


export function VpnConfig({ vpnWithMetrics }: { vpnWithMetrics: VpnWithMetrics }) {
  logger.debug('VpnConfig for: ', vpnWithMetrics)

  return <View fontSize={'0.75rem'}>
    <Flex alignItems={'center'}>
      max 🥜 <Text>{vpnWithMetrics.config.maxPeanuts <= 0 ? '♾️' : vpnWithMetrics.config.maxPeanuts}</Text>
    </Flex>
    <Flex alignItems={'center'}>
      max ⏳ <Text>{vpnWithMetrics.config.deleteAfter ? convertSecondsToHMSShort(vpnWithMetrics.config.deleteAfter) : 'N/A'}</Text>
    </Flex>
    <Flex alignItems={'center'}>
      profile <Text>{getLabelForInstanceType(vpnWithMetrics.config.instanceType!)}</Text >
    </Flex>
  </View>
}